// extracted by mini-css-extract-plugin
module.exports = {"withSidebar":"WithSidebar_withSidebar__Ornk3","sidebar":"WithSidebar_sidebar__iwAZx","body":"WithSidebar_body__r_leS","column":"WithSidebar_column__yNaco"};